const ERROR_MESSAGE_SHOULD_HAVE_PHONE_NUMBER = '전화번호를 입력해주세요';
const ERROR_MESSAGE_INVALID_REGION_NUMBER = '유효한 지역 번호를 입력해주세요';
const ERROR_MESSAGE_INVALID_REGULAR_PHONE_NUMBER = '유효하지 않은 번호입니다';

function isKoreanRegularPhoneNumber(value: string) {
  return /^\d{2,3}[-]?\d{3,4}[-]?\d{4}$/.test(value);
}
/**
 * 유효한 한국 지역 번호 유무를 확인해서 반환합니다.
 * @see https://ko.wikipedia.org/wiki/대한민국의_전화번호_체계#지역_번호_(02,_0NZ)
 * @see https://ko.wikipedia.org/wiki/대한민국의_전화번호_체계#공통_서비스_(0N0)
 */
function isValidRegionNumber(value: string) {
  const regionNumbers = [
    '02',
    '031',
    '032',
    '033',
    '041',
    '042',
    '043',
    '044',
    '051',
    '052',
    '053',
    '054',
    '055',
    '061',
    '062',
    '063',
    '064',
    '030',
    '050',
    '060',
    '070',
  ];

  return regionNumbers.some((regionNumber) => value.startsWith(regionNumber));
}

function validateRegularPhoneNumber(value: string) {
  let message = '';
  let success = false;

  if (!value) {
    message = ERROR_MESSAGE_SHOULD_HAVE_PHONE_NUMBER;
  } else if (!isValidRegionNumber(value)) {
    message = ERROR_MESSAGE_INVALID_REGION_NUMBER;
  } else if (!isKoreanRegularPhoneNumber(value)) {
    message = ERROR_MESSAGE_INVALID_REGULAR_PHONE_NUMBER;
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validateRegularPhoneNumber;
